// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
   region: 'us-east-1',
   identityPoolId: 'us-east-1:eee593a0-eca1-4b02-b961-421d0bbcc25b'
};
